module.exports = __webpack_public_path__ + "img/remove_file.91f22f97.svg";